import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resolveSrc } from './WidgetRender';

export default function SectionSlider({ data }) {
  const cats = data.categories || [];
  const slides = cats.slice(0, 4).map(c => ({
    title: c.name,
    image: resolveSrc(c.products?.[0]?.media?.[0]?.path) || 'https://via.placeholder.com/1400x500?text=Silver',
    link_type: 'category',
    link_value: c.slug,
  }));

  const [i, setI] = useState(0);
  useEffect(() => {
    if (slides.length <= 1) return;
    const t = setInterval(() => setI(p => (p + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, [slides.length]);

  if (!slides.length) return null;
  const s = slides[i];
  const href = s.link_type === 'category' ? `/category/${s.link_value}` : `/products/${s.link_value}`;

  return (
    <section style={{ width: '100%', maxHeight: '520px', minHeight: '300px', padding: '0', overflow: 'hidden', borderRadius: 'var(--shape-card)' }}>
      <div style={{ position: 'relative', width: '100%', minHeight: '280px', overflow: 'hidden' }}>
        {slides.map((sl, idx) => (
          <div key={idx} style={{ position: 'absolute', inset: 0, opacity: idx === i ? 1 : 0, transition: 'opacity 0.8s ease' }}>
            <img src={sl.image} alt={sl.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
          </div>
        ))}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(12,10,9,0.65) 0%, rgba(12,10,9,0.2) 55%, transparent 100%)' }} />
        <div style={{ position: 'absolute', bottom: '10%', right: '6%', color: '#fff', textAlign: 'right', maxWidth: '480px' }}>
          <h1 style={{ fontFamily: 'inherit', fontSize: 'clamp(1.6rem, 5vw, 2.8rem)', fontWeight: '700', margin: 0, textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>{s.title}</h1>
          <Link to={href} className="btn btn-dark" style={{ marginTop: '12px' }}>{s.cta || 'مشاهده محصولات'}</Link>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '14px' }}>
        {slides.map((x, idx) => (
          <button key={idx} onClick={() => setI(idx)} aria-label={`اسلاید ${idx + 1}`} style={{ width: idx === i ? '26px' : '9px', height: '9px', borderRadius: '5px', border: 'none', background: idx === i ? 'var(--accent)' : 'var(--border)', transition: 'width 0.3s', cursor: 'pointer' }} />
        ))}
      </div>
    </section>
  );
}